import TrailResultsMapComponents from '@/components/TrailResultsMapComponents/TrailResultsMapComponents';

/**
 * What the map draws while Ask AllTrails is showing, in place of the page's own map components.
 */
const AskMapComponents = () => <TrailResultsMapComponents />;

export default AskMapComponents;
